import {
  HalfYearExtensionReasonForChildcareLeave,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

// 育児休業登録対象職員
const registrationTargetStaff = "育児休業登録対象職員";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "出生日",
    keyword: "birthday",
    type: "date",
    requiredIcon: true,
    maxDate: new Date("2099/12/31"),
  },
  {
    title: "育児休業開始日",
    keyword: "startDate",
    type: "date",
    requiredIcon: true,
    maxDate: new Date("2099/12/31"),
  },
  {
    title: "育児休業終了（予定）日",
    keyword: "endDate",
    type: "date",
    requiredIcon: true,
    maxDate: new Date("2099/12/31"),
  },
  {
    title: "パパ・ママ育休プラス",
    keyword: "papaMamaPlus",
    type: "radio",
    helpicon: true,
    helpText:
      "パパ・ママ育休プラスの利用有無です。パパ・ママ育休プラスとは、通常、育児休業終了日は子が満1歳に達する日までの期間（誕生日の前日）となりますが、夫婦ともに育児休業を取得することで、1歳2か月まで延長することができる制度です。",
    requiredIcon: true,
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "半年延長の理由",
    keyword: "halfyearExtensionReason",
    type: "radio",
    helpicon: true,
    helpText:
      "選択欄の１，２のいずれかに当てはまる場合、子が１歳6か月（又は2歳）に達するまでの間、育児休業を取得することができます。当てはまる場合は選択してください。",
    radioPropsList: TkGetCodeList(HalfYearExtensionReasonForChildcareLeave),
  },
  {
    title: "産後パパ育休",
    keyword: "papaChildcareLeaveFlg",
    type: "checkboxGroup",
    checkBoxList: [
      {
        label: "有",
      },
    ],
    helpicon: true,
    helpText:
      "当該育児休業申請が産後パパ育休にあたる場合は「有」にチェックを入れてください。産後パパ育休とは、産後8週間以内に4週間（28日）を限度として2回に分けて取得できる休業のことで、1歳までの育児休業とは別に取得できる制度です。",
  },
];

const schema = {
  birthday: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  startDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  endDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  papaMamaPlus: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export { registrationTargetStaff, schema, fakeTableList };
